package com.milta.feature.route.data.remote

import com.milta.core.network.ApiException
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.route.data.remote.dto.AddLoadingAddressRequest
import com.milta.feature.route.data.remote.dto.LoadingAddressDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

/** MIL-99 — the Enterprise's saved loading addresses (Enterprise role only). */
class LoadingAddressApi(private val client: HttpClient) {

    /** GET /api/v1/loading-addresses — already sorted server-side, last used first. */
    suspend fun getLoadingAddresses(): List<LoadingAddressDto> =
        client.get("$baseUrl/${Endpoints.loadingAddresses}").decodeOrThrow()

    /** POST /api/v1/loading-addresses — 201, or 200 with the existing one if the address was already saved. */
    suspend fun addLoadingAddress(request: AddLoadingAddressRequest): LoadingAddressDto =
        client.post("$baseUrl/${Endpoints.loadingAddresses}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.decodeOrThrow()

    /** DELETE /api/v1/loading-addresses/{id} — 204, 404 when not found. */
    suspend fun deleteLoadingAddress(id: String) {
        val response = client.delete("$baseUrl/${Endpoints.loadingAddress(id)}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${status.value}"
            throw ApiException(status.value, message)
        }
        return body()
    }
}
